import React, { ComponentType, createElement, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';

export type RendererOptions = {
  strict?: boolean;
  error?: boolean;
  withQueryClient?: boolean;
};

export default function DOMRender(
  element: HTMLElement,
  component: ComponentType | ComponentType<any>,
  options: RendererOptions = { strict: true, error: true, withQueryClient: false }
): void {
  const dataProps = element.dataset['props'] || '{}';
  const props = JSON.parse(dataProps);

  delete element.dataset['props'];
  delete element.dataset['react'];

  let Component = createElement(component, props);
  if (options.withQueryClient) {
    Component = createElement(SWRConfig, {}, Component);
  }

  const root = createRoot(element);
  root.render(<StrictMode>{Component}</StrictMode>);
}
